@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --collab-item-padding: 10px;
  --collab-item-toggle-padding: 16px;
  --collab-item-reply-input-padding: 12px;
  --collab-item-avatar-size: 24px;
  --collab-item-avatar-gap: 8px;
}

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
[data-autopilot-system-redesign='on']:root {
  --collab-item-padding: 8px;
}

.root {
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 4px;
  @include transition;
  cursor: pointer;
  scroll-margin-bottom: 120px;
  border-radius: 8px;
  position: relative;

  [data-autopilot-system-redesign='on'] & {
    border: 1px solid transparent;
  }

  &.highlighted:not(.editing) {
    border-radius: 6px;
    background: var(--dark-4);

    [data-autopilot-system-redesign='on'] & {
      background-color: var(--light-100);
      box-shadow: none;
      border: 1px solid var(--dark-4);
    }
  }

  &.active {
    @include blur;
    transform: none;
    border-radius: 8px;
    background: var(--light-60);
    box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);

    [data-autopilot-system-redesign='on'] & {
      @include blur(0);
      box-shadow: none;
      border: 1px solid var(--dark-4);
      background: var(--light-100);
    }
  }

  &.editing {
    box-shadow: 0px 2px 6px rgba(19, 21, 26, 0.2);
    transform: none;

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      border: 1px solid var(--dark-4);
    }
  }

  [data-design-system='blaze'] & {
    margin: 0;
  }
}

.controlItem {
  border-radius: 0;
}

.headerContainer {
  padding: 0 6px;
}
